require('./modifyCommerceAndATMLimitsStep1.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @helpers
const { formatText, getLanguage } = require('core/i18n').i18n;
const {
    formatAmountObject,
    getPlainAmountObject,
    getCurrencySymbol,
    formatAmount
} = require('utilities/currencyHelper');
const {
    DEBIT_4B_MC_MUNDO_123_SUBTYPE,
    DEBIT_AT_HOME_ABROAD_SUBTYPE,
    DEBIT_SOLIDARIA_SUBTYPE,
    MINICARD_SUBTYPE,
    OPEN_DEBIT_SUBTYPE,
} = require('constants/contactCenter/debitCardSubtypes');

// @components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const OKSliderInputMiddleLimit = require('components/contactCenter/OKSliderInputMiddleLimit/OKSliderInputMiddleLimit');

// @constants
const {
    FIRST_STEP
} = require('constants/index');

class ModifyCommerceAndATMLimitsStep1 extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            sliderTrackSize: {}
        }
    }


    setCardClass() {
        const { immCard } = this.props;

        const debitCardSubtype = immCard.getIn(['product','subtype']);
        let cardClasses;

        switch (debitCardSubtype) {
            case OPEN_DEBIT_SUBTYPE:
            case DEBIT_4B_MC_MUNDO_123_SUBTYPE:
            case DEBIT_AT_HOME_ABROAD_SUBTYPE:
            case MINICARD_SUBTYPE:
            case DEBIT_SOLIDARIA_SUBTYPE:
                cardClasses = 'modify-commerce-and-atm-limits-step-1__slider modify-commerce-and-atm-limits-step-1__slider--2-color-limit';
                break;
            default:
                cardClasses = 'modify-commerce-and-atm-limits-step-1__slider';
                break;
        }

        return cardClasses;
    }

    handleOnSliderTrackSizeChange = size => {
        this.setState({ sliderTrackSize: size });
    }

    buildSliderSelection() {
        const {
            limitType,
            immCard,
            immModifyCommerceAndATMLimits,
            setLimitAmount
        } = this.props;

        const minimumLimit = immModifyCommerceAndATMLimits.getIn(['limitsData', 'minimumAmount']);
        const maximumLimit = immModifyCommerceAndATMLimits.getIn(['limitsData', 'maximumAmount']);
        const middleLimit = immModifyCommerceAndATMLimits.getIn(['limitsData', 'middleAmount']);
        const currencySign = getCurrencySymbol(immCard.get('limit'));

        const minLabel = formatText('cardModifyLimitSliderSection-minimum', [formatAmount(minimumLimit, undefined, 0), '']);
        const maxLabel = formatText('cardModifyLimitSliderSection-maximumCC', [formatAmount(maximumLimit, undefined, 0), '']);
        const middleLabel = formatText('cardModifyLimitSliderSection-maximum', [formatAmount(middleLimit, undefined, 0), currencySign]);

        const marks = immModifyCommerceAndATMLimits.getIn(['limitsData', 'arrayLimitRanges']);

        const currentLimit = immModifyCommerceAndATMLimits.getIn(['steps', FIRST_STEP, 'newSelectedLimit']);

        const cardClasses = this.setCardClass();

        let sliderProperties = {
            minLabel: minLabel,
            maxLabel: maxLabel,
            defaultValue: currentLimit,
            onChange: setLimitAmount,
            marks: marks,
            minimumLimit: minimumLimit,
            middleLimit: middleLimit,
            maximumLimit: maximumLimit,
            middleLabel: middleLabel,
            currencySign: currencySign
        };

        return(
            <div className="modify-commerce-and-atm-limits-step-1__slide-selection">
                <h2 className="modify-commerce-and-atm-limits-step-1__subtitle">
                    {formatText(`modifyCommerceAndATMLimits-${limitType}SelectTitle`)}
                </h2>
                <div className={cardClasses}>
                    <OKSliderInputMiddleLimit
                        {...sliderProperties}
                    />
                </div>
            </div>
        );
    }

    buildContent() {
        const { immCard, immModifyCommerceAndATMLimits } = this.props;
        const cardAlias = immCard.getIn(['alias', 'current']);
        const cardNumber = immCard.get('number');
        const cardHolder = immCard.get('titularName');
        const sliderSection = this.buildSliderSelection();
        const currentLimitAmountObject = {
            amount: immModifyCommerceAndATMLimits.getIn(['limitsData', 'data', 'importeLimiteActual', 'importe' ]),
            currency: immModifyCommerceAndATMLimits.getIn(['limitsData', 'data', 'importeLimiteActual', 'divisa']),
            decimalsLength: 0
        };

        const language = getLanguage();
        const plainAmountObject = getPlainAmountObject(currentLimitAmountObject);

        return (
            <div className="modify-commerce-and-atm-limits-step-1__content">
                <h2 className="modify-commerce-and-atm-limits-step-1__subtitle">
                    {formatText(`modifyCommerceAndATMLimits-step1Subtitle`, [cardAlias])}
                </h2>
                <div className="modify-commerce-and-atm-limits-step-1__card-details">
                    <OKInformativeList columns={2}>
                        <OKInformativeListItem
                            title="modifyCommerceAndATMLimits-cardNumberLabel"
                            bodyText={cardNumber}
                        />
                        <OKInformativeListItem
                            title="modifyCommerceAndATMLimits-cardHolderLabel"
                            bodyText={cardHolder}
                        />
                        <OKInformativeListItem
                            title="modifyCommerceAndATMLimits-cardLimitLabel"
                        >
                            <OneLineSymbolAmount
                                amountObject={plainAmountObject}
                                language={language}
                                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                            />
                        </OKInformativeListItem>
                    </OKInformativeList>
                </div>
                {sliderSection}
            </div>
        );
    }

    render() {
        const { limitType } = this.props;
        const content = this.buildContent();

        return (
            <article className="modify-commerce-and-atm-limits-step-1">
                <header className="wizard_header">
                    <h1 className="wizard-step--vertical__title">
                        {formatText(`modifyCommerceAndATMLimits-${limitType}Step1Title`)}
                    </h1>
                </header>
                {content}
            </article>
        );
    }
}

ModifyCommerceAndATMLimitsStep1.propTypes = {
    immCard: PropTypes.object.isRequired,
    limitType: PropTypes.string.isRequired,
    immModifyCommerceAndATMLimits: PropTypes.object.isRequired,
    setLimitAmount: PropTypes.func.isRequired
};

module.exports = ModifyCommerceAndATMLimitsStep1;
